<template>
  <div class="l-content">
    <div class="row">
      <div class="col-xs-14 col-xs-offset-2 col-md-8 col-md-offset-2">
        <div class="txt-media__main-content">
          <slot name="main-content"></slot>
        </div>
      </div>
      <div class="col-xs-14 col-xs-offset-2 col-md-5 col-md-offset-1">
        <div class="sidebar-container">
          <slot name="sidebar"></slot>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'TxtMedia',
  props: {

  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
@import '../scss/mixins';
ul, ol {
  padding-bottom: 8px;
  li {
    color: $darker-grey;
  }
}
.txt-media {
  &__main-content {
    h2 {
      color: $grey;
      margin-bottom: 28px;
    }
    h3 {
      color: $h3-grey;
      margin-bottom: 12px;
    }
    p {
      color: $darker-grey;
      margin-bottom: 18px;
    }
  }
}

.sidebar-container {
  color: white;
  img, iframe {
    max-width: 100%;
  }
  img.logo {
    max-width: 125px;
  }
  img.logo-smaller {
    max-width: 80px;
    margin: 0 auto;
  }
  img.mw-320 {
    max-width: 320px;
  }
  p {
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/TxtMedia.vue